import { render, staticRenderFns } from "./ListGroupSkeleton.vue?vue&type=template&id=56753945"
import script from "./ListGroupSkeleton.vue?vue&type=script&lang=js"
export * from "./ListGroupSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ListGroupSkeleton.vue?vue&type=style&index=0&id=56753945&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports